export function githubPath(path: string, branch = 'dev') {
  return `https://github.com/ulule/ulule/tree/${branch}/frontend/owl-nest/external/owl-kit/${path}`
}
